import styled from 'styled-components';
import { Modal as SemanticModal } from 'semantic-ui-react';

import { Button as ButtonLayoutComponent } from '@playbookux/playbook-web-core';

const Modal = styled(SemanticModal)`
  &.ui.modal {
    width: fit-content;
  }
`;

const Content = styled(SemanticModal.Content)``;

const StepCircle = styled.div`
  background-color: ${(props) => (props.active ? props.theme.color.primary : props.theme.color.textMuted)};
  height: 8px;
  width: 8px;
  border-radius: 4px;
  display: inline-block;
  margin: 7px;
`;

const ContainerCircles = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  margin-bottom: 15px;
`;

const Actions = styled(SemanticModal.Actions)``;

const Button = styled(ButtonLayoutComponent)`
`;

const BackButton = styled(ButtonLayoutComponent.Inverted)``;

const ContainerButtons = styled.div`
  display:flex;
  flex-direction: row;
`;

const LeftContainer = styled.div``;

const RightContainer = styled.div``;

const GrowCenter = styled.div`
  flex-grow: 1;
`;

export {
  Modal,
  Content,
  StepCircle,
  ContainerCircles,
  Actions,
  Button,
  BackButton,
  ContainerButtons,
  LeftContainer,
  RightContainer,
  GrowCenter,
};
